import { render, staticRenderFns } from "./org.vue?vue&type=template&id=1ddb068a&scoped=true&"
import script from "./org.vue?vue&type=script&lang=js&"
export * from "./org.vue?vue&type=script&lang=js&"
import style0 from "./org.vue?vue&type=style&index=0&id=1ddb068a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddb068a",
  null
  
)

export default component.exports